"use strict";
"use client";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DormantMarkers = void 0;
const react_google_maps_1 = require("@vis.gl/react-google-maps");
const react_1 = __importStar(require("react"));
const colors_1 = require("../../../../assets/styles/colors");
const fixedStreamSelectors_1 = require("../../../../store/fixedStreamSelectors");
const hooks_1 = require("../../../../store/hooks");
const mapSlice_1 = require("../../../../store/mapSlice");
const markersLoadingSlice_1 = require("../../../../store/markersLoadingSlice");
const CustomMarker_1 = require("./CustomOverlays/CustomMarker");
const HoverMarker_1 = __importDefault(require("./HoverMarker/HoverMarker"));
const ZOOM_FOR_SELECTED_SESSION = 15;
const CLICKABLE_AREA_SIZE = 20;
const DormantMarkers = ({ sessions, onMarkerClick, selectedStreamId, pulsatingSessionId, }) => {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const hoverStreamId = (0, hooks_1.useAppSelector)(mapSlice_1.selectHoverStreamId);
    const fixedStreamStatus = (0, hooks_1.useAppSelector)(fixedStreamSelectors_1.selectFixedStreamStatus);
    const fixedStreamData = (0, hooks_1.useAppSelector)(fixedStreamSelectors_1.selectFixedStreamData);
    const markerRefs = (0, react_1.useRef)(new Map());
    const map = (0, react_google_maps_1.useMap)();
    const [hoverPosition, setHoverPosition] = (0, react_1.useState)(null);
    const memoizedSessions = (0, react_1.useMemo)(() => sessions, [sessions]);
    const centerMapOnMarker = (0, react_1.useCallback)((position) => {
        if (map && selectedStreamId) {
            map.setCenter(position);
            map.setZoom(ZOOM_FOR_SELECTED_SESSION);
        }
    }, [map, selectedStreamId]);
    const createMarker = (0, react_1.useCallback)((session) => {
        const position = session.point;
        const color = colors_1.gray300;
        const title = "";
        const size = 12;
        const shouldPulse = session.id === pulsatingSessionId;
        const marker = new ((0, CustomMarker_1.getCustomMarkerClass)())(position, color, title, size, CLICKABLE_AREA_SIZE, undefined, undefined, undefined, () => {
            onMarkerClick(Number(session.point.streamId), Number(session.id));
            centerMapOnMarker(position);
            hideOtherMarkers(session.point.streamId);
        });
        marker.setPulsating(shouldPulse);
        marker.setMap(map);
        return marker;
    }, [map, onMarkerClick, centerMapOnMarker, pulsatingSessionId]);
    const hideOtherMarkers = (0, react_1.useCallback)((selectedStreamId) => {
        markerRefs.current.forEach((marker, streamId) => {
            if (streamId !== selectedStreamId) {
                marker.setMap(null);
            }
        });
    }, []);
    const showAllMarkers = (0, react_1.useCallback)(() => {
        markerRefs.current.forEach((marker) => {
            marker.setMap(map);
        });
    }, [map]);
    (0, react_1.useEffect)(() => {
        if (!map)
            return;
        sessions.forEach((session) => {
            const markerId = session.point.streamId;
            let marker = markerRefs.current.get(markerId);
            if (!marker) {
                marker = createMarker(session);
                markerRefs.current.set(markerId, marker);
            }
            else {
                marker.setPosition(session.point);
                marker.setPulsating(session.id === pulsatingSessionId);
            }
        });
        const sessionStreamIds = new Set(sessions.map((s) => s.point.streamId));
        markerRefs.current.forEach((marker, markerId) => {
            if (!sessionStreamIds.has(markerId)) {
                marker.setMap(null);
                markerRefs.current.delete(markerId);
            }
        });
        return () => {
            markerRefs.current.forEach((marker) => marker.setMap(null));
            markerRefs.current.clear();
        };
    }, [sessions, map, createMarker, pulsatingSessionId]);
    (0, react_1.useEffect)(() => {
        const handleSelectedStreamId = (streamId) => {
            if (!streamId || fixedStreamStatus === "PENDING" /* StatusEnum.Pending */) {
                showAllMarkers();
                return;
            }
            const { latitude, longitude } = fixedStreamData.stream;
            if (latitude && longitude) {
                const fixedStreamPosition = { lat: latitude, lng: longitude };
                centerMapOnMarker(fixedStreamPosition);
                hideOtherMarkers(streamId.toString());
            }
            else {
                console.error(`Stream ID ${streamId} not found or missing latitude/longitude in fixedStream data.`);
            }
        };
        handleSelectedStreamId(selectedStreamId);
    }, [
        selectedStreamId,
        fixedStreamData,
        fixedStreamStatus,
        centerMapOnMarker,
        hideOtherMarkers,
        showAllMarkers,
    ]);
    (0, react_1.useEffect)(() => {
        if (hoverStreamId) {
            const hoveredSession = memoizedSessions.find((session) => Number(session.point.streamId) === hoverStreamId);
            if (hoveredSession) {
                setHoverPosition(hoveredSession.point);
            }
        }
        else {
            setHoverPosition(null);
        }
    }, [hoverStreamId, memoizedSessions]);
    (0, react_1.useEffect)(() => {
        if (markerRefs.current.size >= sessions.length) {
            dispatch((0, markersLoadingSlice_1.setMarkersLoading)(false));
        }
    }, [dispatch, sessions.length]);
    return hoverPosition ? react_1.default.createElement(HoverMarker_1.default, { position: hoverPosition }) : null;
};
exports.DormantMarkers = DormantMarkers;
